import { PayloadCaseTableViewResultType } from 'app/area/case-report/case-table-view/types-store';
export const ACTION = {
  REQUEST_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REQUEST',
  REPLACE_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REPLACE',
  APPEND_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:APPEND',
  FAIL_EXECUTE_FAVOURITE_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:FAIL_EXECUTE_FAVOURITE',
  CLEAR_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:CLEAR',
  REMOVE_ITEM_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REMOVE_ITEM',
  REQUEST_REMOVE_ITEM_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REQUEST_REMOVE_ITEM',
  REQUEST_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REQUEST_SINGLE_SUPPLIER_URL',
  RECEIVE_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:RECEIVE_SINGLE_SUPPLIER_URL'
};

export type RequestCaseViewTableActionType = {
  type: typeof ACTION.REQUEST_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
  };
}

export interface CaseViewTableResultReplaceActionType {
  type: typeof ACTION.REPLACE_CASE_VIEW_TABLE;
  payload: PayloadCaseTableViewResultType;
}

export interface CaseViewTableResultAppendActionType {
  type: typeof ACTION.APPEND_CASE_VIEW_TABLE;
  payload: PayloadCaseTableViewResultType;
}

export interface FailExecuteFavouriteActionType {
  type: typeof ACTION.FAIL_EXECUTE_FAVOURITE_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    errorsExecuteFailed: string[];
  };
}

export interface CaseViewTableClearActionType {
  type: typeof ACTION.CLEAR_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
  };
}

export interface CaseViewTableRequestRemoveItemActionType {
  type: typeof ACTION.REQUEST_REMOVE_ITEM_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    caseId: number;
  };
}

export interface CaseViewTableRemoveItemActionType {
  type: typeof ACTION.REMOVE_ITEM_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    caseId: number;
  };
}

export interface CaseViewTableRequestSingleSupplierUrlActionType {
  type: typeof ACTION.REQUEST_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
  };
}
export interface CaseViewTableReceiveSingleSupplierUrlActionType {
  type: typeof ACTION.RECEIVE_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    singleSupplierUrl: string;
  };
}


export type CaseTableActionType = CaseViewTableResultAppendActionType |
  CaseViewTableResultReplaceActionType | RequestCaseViewTableActionType |
  FailExecuteFavouriteActionType | CaseViewTableClearActionType |
  CaseViewTableRequestRemoveItemActionType | CaseViewTableRemoveItemActionType | 
  CaseViewTableRequestSingleSupplierUrlActionType | CaseViewTableReceiveSingleSupplierUrlActionType;
